'use strict';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Button, Icon, InputCollectionSelect } from 'dumb';
import { TableList, TableListRow, TableListCell } from 'dumb/tables/table-list';

// phrases
import phrases from './../../../marketShiftRules.phrases';

// lodash
import _get from 'lodash/get';

// utils
import { getOptions } from 'services/utils/marketShiftRules';

class MarketShiftRulesBatchStepList extends Component {
	_onRemoveEntry(identifier) {
		const { removeBatchListItem } = this.props;

		removeBatchListItem(identifier);
	}

	_editListEntry(e, row, type) {
		// edits the row in the store
		this.props.editBatchListItem({
			...row,
			...{ [type]: e },
		});
	}

	render() {
		const { batchListData } = this.props;

		return (
			<TableList>
				<thead>
					<tr>
						<th>{phrases.MODAL_BATCH_STEP_LIST_TABLE_NUMBER}</th>
						<th>{phrases.MODAL_BATCH_STEP_MARKET}</th>
						<th>{phrases.MODAL_BATCH_STEP_RULE}</th>
						<th />
					</tr>
				</thead>
				<tbody>
					{batchListData.map((entry, i) => {
						return (
							<TableListRow key={entry.identifier}>
								<TableListCell>{i + 1}</TableListCell>
								<TableListCell>{_get(entry, 'market.label', '')}</TableListCell>

								<TableListCell>
									<InputCollectionSelect
										id={`${entry.identifier}-rule`}
										value={entry.rule}
										handleChange={(key, value) =>
											this._editListEntry(value, entry, 'rule')
										}
										options={getOptions()}
										clearable={false}
									/>
								</TableListCell>

								<TableListCell>
									<Button
										id={`${entry.identifier}-delete`}
										type="negative"
										size="tiny"
										onClick={() => this._onRemoveEntry(entry.identifier)}>
										<Icon name="delete" />
									</Button>
								</TableListCell>
							</TableListRow>
						);
					})}
				</tbody>
			</TableList>
		);
	}
}

MarketShiftRulesBatchStepList.propTypes = {
	batchListData: PropTypes.array,
	editBatchListItem: PropTypes.func,
	removeBatchListItem: PropTypes.func,
};

export default MarketShiftRulesBatchStepList;
